export class ApiError extends Error {
  constructor(message: string, public status: number) {
    super(message)
  }
}

function detailMessage(payload: unknown, fallback: string): string {
  if (!payload || typeof payload !== 'object') return fallback
  const detail = (payload as { detail?: unknown }).detail
  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object' && 'message' in detail) {
    return String((detail as { message?: unknown }).message || fallback)
  }
  if (Array.isArray(detail)) {
    return detail.map((item) => {
      if (!item || typeof item !== 'object') return String(item)
      const row = item as { loc?: string[]; msg?: string }
      return `${row.loc?.slice(1).join('.') || ''} ${row.msg || ''}`.trim()
    }).join('；')
  }
  return fallback
}

export async function api<T>(path: string, init: Omit<RequestInit, 'body'> & { body?: unknown } = {}): Promise<T> {
  const headers = new Headers(init.headers)
  let body = init.body as BodyInit | null | undefined
  if (body && !(body instanceof FormData) && typeof body !== 'string' && !(body instanceof Blob)) {
    headers.set('Content-Type', 'application/json')
    body = JSON.stringify(body)
  }
  const response = await fetch(path, { ...init, body, headers, credentials: 'include' })
  if (!response.ok) {
    let payload: unknown
    try { payload = await response.json() } catch { payload = null }
    throw new ApiError(detailMessage(payload, response.statusText || '请求失败'), response.status)
  }
  if (response.status === 204) return undefined as T
  return response.json() as Promise<T>
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '')
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

export async function uploadPresigned(uploadUrl: string, method: string, headers: Record<string, string>, file: File) {
  const response = await fetch(uploadUrl, { method: method || 'PUT', headers, body: file, credentials: 'omit' })
  if (!response.ok) throw new Error(`文件上传失败 (${response.status})`)
}
